export default __webpack_public_path__ + "static/plus-light-mode-83ecb832114eab3cd7e194cca686e832.mp4";